import { Box } from "@mui/material";
import { useState } from "react";
import ChangeStatusDialog from "./ChangeStatusDialog";

export default function ActionRowButtons({ row, addSnackbar, fetchPos }) {
  const [buttonLoading, setButtonLoading] = useState(false);

  return (
      row.actions.includes("change_status") && (
        <Box>
          <ChangeStatusDialog
            buttonLoading={buttonLoading}
            setButtonLoading={setButtonLoading}
            po_doc_id={row.doc_id}
            poName={row.name}
            addSnackbar={addSnackbar}
            fetchPos={fetchPos}
          />
        </Box>
      )
  );
}